import React from 'react'

import HeroMain from '../components/HeroMain'

import Trackable from './Trackable'
import MetaTags from './MetaTags'

const TAGS = {
    title: 'Intento 404',
    og: { title: 'Intento 404', url: 'https://inten.to/404' },
}

const NotFound = () => (
    <Trackable page="404">
        <MetaTags tags={TAGS} />
        <HeroMain />
        <section className="section features-section">
            <div className="section__container container">
                <header className="section__header">
                    <h2 className="section__title h2">
                        404 - Oh no&apos;s! We couldn&apos;t find that page :(
                    </h2>
                </header>
            </div>
        </section>
    </Trackable>
)

export default NotFound



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/404.jsx